export const reduce = (orderLines, fn, initial) => {
    let acc = initial;
    orderLines.forEach((ol) => {
        acc = fn(acc, ol);
        if (ol.subLines.length > 0) {
            acc = reduce(ol.subLines, fn, acc);
        }
    });
    return acc;
};
export const reduceWithParent = (orderLines, fn, initial, parent) => {
    let acc = initial;
    orderLines.forEach((ol) => {
        if (ol.subLines.length > 0) {
            acc = reduceWithParent(ol.subLines, fn, acc, ol);
        }
        acc = fn(acc, ol, parent);
    });
    return acc;
};
export const reduceRightWithParent = (orderLines, fn, initial, parent) => {
    let acc = initial;
    orderLines
        .slice(0)
        .reverse()
        .forEach((ol) => {
        if (ol.subLines.length > 0) {
            acc = reduceWithParent(ol.subLines, fn, acc, ol);
        }
        acc = fn(acc, ol, parent);
    });
    return acc;
};
export const reduceRight = (orderLines, fn, initial) => reduce(orderLines, (acc, curr) => [curr, ...acc], []).reduce(fn, initial);
export function makeOrderLinesBackwardsCompatibleG5(topLevelOrderLines) {
    return topLevelOrderLines.map((ol) => {
        if ('type' in ol && ol.type === 'Nps') {
            return Object.assign(Object.assign({}, ol), { type: 'Meta' });
        }
        return ol;
    });
}
export { computeTotalPrice } from './PriceCalculation';
